import React, { useEffect, useState } from 'react'
import Modal from 'react-modal'
import './CustomModal.scss'
Modal.setAppElement('*')

const CustomModal = ({ children, showModal, width, maxWidth, toggleModal, height, onClosePropertyModal, footerLink, currentPath }: any) => {
  const [windowOffset, setWindowOffset] = useState(0)
  const customStyle = {
    content: {
      width: width || '75%',
      height: height || '100%',
      maxWidth: maxWidth ? maxWidth : 'auto',
      padding: 0
    }
  }

  useEffect(() => {
    if (showModal) {
      document.body.style.overflow = 'scroll'
    }
    return () => {
      document.body.style.overflow = 'unset'
    }
  }, [showModal])

  return (
    <Modal isOpen={showModal} style={customStyle} shouldFocusAfterRender={false}>
      <span
        className="alp-modal-close"
        onClick={() => {
          onClosePropertyModal ? onClosePropertyModal() : toggleModal(false)
          footerLink && window.history.pushState('', '', `${currentPath ? currentPath : '/'}`)
        }}
      >
        &times;
      </span>
      {children}
    </Modal>
  )
}

export default CustomModal
